import React from 'react';
import PropTypes from 'prop-types';
import './message-banner.scss';

export default class MessageBanner extends React.PureComponent {
  static propTypes = {
    icon: PropTypes.string,
    heading: PropTypes.string,
    content: PropTypes.node
  };

  render() {
    const {icon, heading, content} = this.props;
    const iconEl = icon ? <div className={`message-banner__icon fa fa-${icon}`} /> : null;
    return (
      <section className='message-banner card'>
        {iconEl}
        <div className='message-banner__content-wrapper'>
          <h1 className='message-banner__heading'>{heading}</h1>
          {content}
        </div>
      </section>
    );
  }
}
